import axiosInstance from '../api/axios';
import { EeMyContactGroup, EeMyContactGroupCreate, EeMyContactGroupUpdate } from '../types/eeMyContactGroups';

const BASE = '/api/ee_my_contact_groups';

export const getGroups = async (): Promise<EeMyContactGroup[]> => {
  const res = await axiosInstance.get<EeMyContactGroup[]>(`${BASE}/`);
  return res.data;
};

export const createGroup = async (data: EeMyContactGroupCreate): Promise<EeMyContactGroup> => {
  const res = await axiosInstance.post<EeMyContactGroup>(`${BASE}/`, data);
  return res.data;
};

export const updateGroup = async (id: number, data: EeMyContactGroupUpdate): Promise<EeMyContactGroup> => {
  const res = await axiosInstance.put<EeMyContactGroup>(`${BASE}/${id}`, data);
  return res.data;
};

export const deleteGroup = async (id: number): Promise<void> => {
  await axiosInstance.delete(`${BASE}/${id}`);
};

export const addMembers = async (groupId: number, contactIds: number[]): Promise<void> => {
  await axiosInstance.post(`${BASE}/${groupId}/members`, { contact_ids: contactIds });
};

export const removeMembers = async (groupId: number, contactIds: number[]): Promise<void> => {
  await axiosInstance.delete(`${BASE}/${groupId}/members`, { data: { contact_ids: contactIds } });
};

export const batchDeleteContacts = async (groupId: number, contactIds?: number[]): Promise<void> => {
  await axiosInstance.delete(`${BASE}/${groupId}/contacts`, {
    data: { contact_ids: contactIds ?? null },
  });
};
